import React from "react";
import "./styles.css";
import SafeArea from "../safe-area";
import { IgSVG } from "../../../constants/svgs";
import { useHistory } from "react-router-dom";
import { useI18n } from "../../../i18n/i18n";

const FooterMobile: React.FC = () => {
    const history = useHistory();
    const { t } = useI18n();

    const contacts = [
        {
            id: 1,
            email: "nuria.frigola@teatrolaplaza.com",
            typeKey: "sections.filmContact",
        },
        {
            id: 2,
            email: "roxana.rodriguez@teatrolaplaza.com",
            typeKey: "sections.playContact",
        },
        {
            id: 3,
            email: "info@teatrolaplaza.com",
            typeKey: "sections.otherIssues",
        },
    ] as const;

    return (
        <div
            id="contacto-mobile"
            className="footer-mobile w100"
            style={{ backgroundColor: "#F11616", color: "#FFFFFF" }}
        >
            <SafeArea>
                <div className="footer-body-mobile">
                    <div>
                        <div className="fs48 fw700" style={{ width: "fit-content", paddingBottom: "57px" }}>
                            {t("nav.contact")}
                        </div>
                    </div>

                    <div style={{ backgroundColor: "#FFFFFF", width: "100%", height: "1px" }} />

                    <div className="d-flex flex-col w100 jcsb" style={{ paddingTop: 16 }}>
                        {contacts.map((contact) => (
                            <div key={contact.id} className="flex1">
                                <div className="fs12 pointer" style={{ width: "fit-content", paddingBottom: "70px" }}>
                                    <a className="cormorant uppercase" href={`mailto:${contact.email}`}>
                                        {t(contact.typeKey)}
                                    </a>
                                    <div className="fs16 fw600" style={{ marginTop: 40, textDecoration: "underline" }}>
                                        {contact.email}
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="flex1">
                            <div className="fs12 pointer" style={{ width: "fit-content" }}>
                                <a
                                    className="fw700 fs14 d-flex aic gap4 mb6"
                                    href="https://www.instagram.com/teatrolaplaza"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <IgSVG />
                                    TeatroLaPlaza
                                </a>

                                <a
                                    className="fw700 fs14 d-flex aic gap4 mb6"
                                    href="https://www.instagram.com/hamletlaplaza"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <IgSVG />
                                    HamletLaPlaza
                                </a>

                                <div
                                    className="fs16 fw700"
                                    onClick={() => history.push("/newsletter")}
                                    style={{ textDecoration: "underline" }}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") history.push("/newsletter");
                                    }}
                                >
                                    {t("nav.newsletter")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SafeArea>
        </div>
    );
};

export default FooterMobile;
